import { isObject } from 'error-handler/helper/utils';
import sendError from 'error-handler/functions/sendError';

interface IMeta {
  Function?: string;
  Component?: string;
  Line?: number;
  Author?: string;
}

const service =
  (...arg: any) =>
  (fn: string | IMeta | Function) => {
    if (typeof fn === 'function') {
      try {
        fn(...arg);
      } catch (err) {
        sendError({ error: err });
      }

      return () => ({});
    }

    return (callback: Function) => {
      try {
        callback(...arg);
      } catch (err) {
        sendError({
          error: err, // @ts-ignore
          funcName: isObject(fn) ? '' : fn, // @ts-ignore
          metaInfo: isObject(fn) ? fn : {},
        });
      }
    };
  };

export default service;
